import React, { useEffect, useMemo, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../app/Config/firebase";
import "./siteSaas.css";

const VERSAO_TERMOS = "2026-08-01";

function ContratoLicencaModal({ onClose }) {
  return (
    <div className="qs-terms-overlay" role="presentation" onMouseDown={onClose}>
      <section
        className="qs-terms-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="qs-terms-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="qs-terms-header">
          <div>
            <span className="qs-kicker">Versão {VERSAO_TERMOS}</span>
            <h2 id="qs-terms-title">Termos de Licença de Uso e Contrato de Prestação de Serviços SaaS</h2>
          </div>
          <button type="button" className="qs-terms-close" onClick={onClose} aria-label="Fechar contrato">×</button>
        </header>

        <article className="qs-terms-content">
          <p>
            Este instrumento regula o acesso e a utilização da plataforma QualiInfra. Para fins destes Termos,
            considera-se <strong>CONTRATADA</strong> a pessoa jurídica responsável pela disponibilização da QualiInfra,
            identificada na proposta comercial, documento de contratação ou documento fiscal, e
            <strong> CONTRATANTE</strong> a empresa ou profissional identificado no cadastro eletrônico, representado
            pela pessoa que realiza o aceite.
          </p>

          <h3>1. Aceite eletrônico e capacidade</h3>
          <p>
            Ao marcar a opção de aceite e iniciar a demonstração, o usuário declara que leu e concorda com estes
            Termos, que possui capacidade legal e, quando agir em nome de uma empresa, poderes para vinculá-la. O
            cadastro, a versão aceita, a data e os registros técnicos relacionados ao aceite poderão ser conservados
            como evidência da contratação eletrônica.
          </p>

          <h3>2. Objeto e licença de uso</h3>
          <p>
            A CONTRATADA concede à CONTRATANTE uma licença limitada, temporária, revogável, não exclusiva,
            intransferível e sem direito de sublicenciamento para acessar a QualiInfra pela internet. A plataforma
            apoia rotinas de engenharia e gestão da qualidade, incluindo cadastros de clientes, obras, materiais,
            equipamentos e usuários; gestão de ensaios; moldagens e rupturas; relatórios e laudos; rastreabilidade;
            SGQ; indicadores; ocorrências; aprovações e demais módulos disponibilizados no plano aplicável.
          </p>

          <h3>3. Demonstração gratuita</h3>
          <p>
            A demonstração terá duração de 7 (sete) dias corridos, contados da criação do ambiente. Durante esse
            período, poderão ser disponibilizados todos os recursos existentes para avaliação, sem cobrança e sem
            conversão automática em plano pago. Encerrado o prazo, o acesso poderá ser suspenso. A continuidade
            dependerá da contratação de um plano disponível e da aceitação das respectivas condições comerciais.
            Para evitar usos repetidos da gratuidade, poderá ser utilizado um identificador protegido da rede.
          </p>

          <h3>4. Planos, preços e limites</h3>
          <p>
            Após a demonstração, quantidade de usuários, obras, módulos, armazenamento, suporte, preço, vencimento e
            demais limites serão aqueles do plano escolhido ou da proposta comercial aceita. Mudanças de plano
            poderão alterar os recursos disponíveis. Nenhum valor será devido apenas pela demonstração gratuita.
          </p>

          <h3>5. Recursos existentes e ausência de personalização</h3>
          <p>
            A CONTRATANTE deverá avaliar, durante a demonstração, se os recursos e fluxos existentes atendem às suas
            necessidades. A licença não inclui desenvolvimento sob encomenda, alteração exclusiva, integração,
            migração ou personalização, salvo quando expressamente prevista em proposta específica. Sugestões poderão
            ser analisadas para a evolução geral do produto, sem obrigação ou prazo de implementação.
          </p>

          <h3>6. Contas, usuários e segurança</h3>
          <p>
            A CONTRATANTE é responsável por cadastrar apenas usuários autorizados, definir seus perfis, manter senhas
            e credenciais em sigilo e comunicar imediatamente suspeitas de acesso indevido. Os atos realizados por
            contas regularmente autenticadas serão atribuídos à CONTRATANTE, ressalvadas falhas comprovadamente
            imputáveis à CONTRATADA.
          </p>

          <h3>7. Responsabilidade técnica e conteúdo inserido</h3>
          <p>
            A CONTRATANTE responde pela exatidão dos dados, cálculos de entrada, critérios, documentos, normas,
            resultados, assinaturas, laudos e demais conteúdos inseridos ou emitidos por seus usuários. A QualiInfra é
            uma ferramenta de organização, processamento, armazenamento e rastreabilidade e não substitui a análise,
            validação ou responsabilidade de profissional legalmente habilitado. A plataforma não garante certificação
            ISO 9001, PBQP-H ou atendimento automático a qualquer norma técnica.
          </p>

          <h3>8. Uso permitido e propriedade intelectual</h3>
          <p>
            A titularidade da plataforma, código, estrutura, marca, interfaces, documentação e evoluções permanece com
            seus respectivos proprietários. É proibido copiar, vender, sublicenciar, disponibilizar acesso a terceiros
            não autorizados, realizar engenharia reversa, contornar controles de segurança, explorar vulnerabilidades
            ou utilizar a plataforma para finalidade ilícita ou que viole direitos de terceiros.
          </p>

          <h3>9. Dados pessoais e privacidade</h3>
          <p>
            Os dados de cadastro, contato, autenticação, segurança e contratação poderão ser tratados pela CONTRATADA
            para executar estes Termos, prestar suporte, prevenir fraude, proteger a plataforma e cumprir obrigações
            legais. Quanto aos dados pessoais inseridos pela CONTRATANTE em sua operação, esta definirá as finalidades
            e bases legais do tratamento, cabendo à CONTRATADA tratá-los para disponibilizar o serviço e conforme as
            instruções legítimas da CONTRATANTE, observada a legislação aplicável. O ambiente de cada empresa será
            logicamente separado por controles de acesso.
          </p>

          <h3>10. Disponibilidade, manutenção e atualizações</h3>
          <p>
            A CONTRATADA adotará esforços tecnicamente razoáveis para manter o serviço disponível e seguro, mas não
            garante funcionamento ininterrupto ou livre de falhas. Poderão ocorrer manutenções, atualizações, falhas de
            internet, indisponibilidade de fornecedores de infraestrutura ou eventos fora de seu controle. Recursos
            poderão ser corrigidos, aprimorados ou modificados para segurança, desempenho e evolução do produto,
            preservado o núcleo do serviço contratado.
          </p>

          <h3>11. Suporte</h3>
          <p>
            O atendimento será prestado pelos canais e horários informados no plano ou na proposta comercial. O suporte
            abrange orientação sobre o uso da plataforma e correção de falhas reproduzíveis, não incluindo consultoria
            de engenharia, elaboração de documentos técnicos, operação do sistema em nome da CONTRATANTE ou treinamento
            adicional não contratado.
          </p>

          <h3>12. Suspensão e encerramento</h3>
          <p>
            O acesso poderá ser suspenso ao fim da demonstração, por inadimplência, risco de segurança, uso abusivo,
            violação destes Termos ou determinação legal. No encerramento, a CONTRATANTE deverá solicitar ou realizar a
            exportação dos dados disponíveis dentro do prazo comunicado. Dados e registros poderão ser conservados ou
            eliminados conforme obrigações legais, necessidades de segurança, política de retenção e solicitações
            legítimas dos titulares.
          </p>

          <h3>13. Responsabilidade</h3>
          <p>
            Cada parte responderá pelos danos diretos que causar por descumprimento comprovado de suas obrigações. A
            CONTRATADA não responde por decisões técnicas tomadas exclusivamente com base nos registros da plataforma,
            dados incorretos inseridos pela CONTRATANTE, uso por pessoas não autorizadas decorrente de falha na guarda
            de credenciais, serviços de terceiros ou eventos de força maior, respeitados os limites inderrogáveis da
            legislação aplicável.
          </p>

          <h3>14. Comunicações e alterações</h3>
          <p>
            Comunicações poderão ser realizadas pelo e-mail, WhatsApp ou avisos na plataforma. Estes Termos poderão ser
            atualizados por razões legais, técnicas ou comerciais. Quando a alteração for relevante, será solicitado
            novo aceite ou apresentada comunicação prévia, conforme aplicável.
          </p>

          <h3>15. Disposições gerais e foro</h3>
          <p>
            A eventual invalidade de uma cláusula não afetará as demais. A tolerância não constituirá renúncia de
            direito. Aplicam-se as leis da República Federativa do Brasil. Eventuais controvérsias serão submetidas ao
            foro brasileiro legalmente competente, preservados os direitos de foro assegurados por norma obrigatória.
          </p>

          <p className="qs-terms-note">
            A identificação jurídica completa da CONTRATADA e as condições financeiras do plano constarão da proposta
            comercial, documento de contratação ou documento fiscal correspondente.
          </p>
        </article>

        <footer className="qs-terms-footer">
          <button type="button" className="qs-button qs-button-primary" onClick={onClose}>Fechar e voltar ao cadastro</button>
        </footer>
      </section>
    </div>
  );
}

function normalizarCelularBrasil(valor) {
  const digitos = String(valor || "").replace(/\D/g, "");
  return digitos.length === 13 && digitos.startsWith("55")
    ? digitos.slice(2)
    : digitos;
}

function celularBrasilValido(valor) {
  return /^(?:1[1-9]|2[12478]|3[1-578]|4[1-9]|5[1345]|6[1-9]|7[134579]|8[1-9]|9[1-9])9\d{8}$/
    .test(normalizarCelularBrasil(valor));
}

function formatarCelularBrasil(valor) {
  const digitos = normalizarCelularBrasil(valor).slice(0, 11);
  if (digitos.length <= 2) return digitos;
  if (digitos.length <= 7) return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`;
  return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
}

const estadoInicial = {
  nome: "",
  empresa: "",
  email: "",
  whatsapp: "",
  senha: "",
  confirmarSenha: "",
  aceitouTermos: false,
};

export default function Demonstracao() {
  const [formulario, setFormulario] = useState(estadoInicial);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const [expiraEm, setExpiraEm] = useState("");
  const [mostrarContrato, setMostrarContrato] = useState(false);
  const criarDemonstracao = useMemo(
    () => httpsCallable(functions, "criarDemonstracao"),
    []
  );

  useEffect(() => {
    if (!mostrarContrato) return undefined;

    const overflowAnterior = document.body.style.overflow;
    const fecharComEscape = (event) => {
      if (event.key === "Escape") setMostrarContrato(false);
    };
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", fecharComEscape);

    return () => {
      document.body.style.overflow = overflowAnterior;
      document.removeEventListener("keydown", fecharComEscape);
    };
  }, [mostrarContrato]);

  if (process.env.REACT_APP_ENV === "prod") {
    return <Redirect to="/" />;
  }

  function atualizarCampo(event) {
    const { name, value, checked, type } = event.target;
    setFormulario((atual) => ({
      ...atual,
      [name]: type === "checkbox"
        ? checked
        : name === "whatsapp"
          ? formatarCelularBrasil(value)
          : value,
    }));
  }

  async function enviar(event) {
    event.preventDefault();
    setErro("");

    if (!celularBrasilValido(formulario.whatsapp)) {
      setErro("Informe um celular válido com DDD, no formato (XX) 9XXXX-XXXX.");
      return;
    }

    if (formulario.senha !== formulario.confirmarSenha) {
      setErro("As senhas informadas não coincidem.");
      return;
    }

    setEnviando(true);
    try {
      const resultado = await criarDemonstracao({
        nome: formulario.nome.trim(),
        empresa: formulario.empresa.trim(),
        email: formulario.email.trim(),
        whatsapp: normalizarCelularBrasil(formulario.whatsapp),
        senha: formulario.senha,
        aceitouTermos: formulario.aceitouTermos,
        versaoTermos: VERSAO_TERMOS,
      });
      setExpiraEm(resultado.data.expiraEm);
    } catch (error) {
      const mensagem = String(error?.message || "");
      if (error?.code === "functions/already-exists") {
        setErro(mensagem.includes("rede")
          ? "Esta rede já utilizou uma demonstração gratuita. Fale conosco pelo WhatsApp."
          : "Este e-mail já possui cadastro.");
      } else {
        setErro(mensagem || "Não foi possível criar a demonstração. Tente novamente.");
      }
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="qs-site qs-public-page">
      <header className="qs-public-header">
        <Link to="/" aria-label="Voltar à página inicial">
          <img src="/Images/logoSiteSAAS.png" alt="Qualinfra" />
        </Link>
        <Link to="/app">Já sou cliente</Link>
      </header>

      <main className="qs-public-main">
        <section className="qs-public-copy">
          <span className="qs-kicker">Demonstração gratuita</span>
          <h1>Use a QualiInfra por 7 dias.</h1>
          <p>Crie o ambiente da sua empresa e teste os recursos da plataforma sem compromisso.</p>
          <ul>
            <li>✓ Acesso completo durante o período de demonstração</li>
            <li>✓ Ambiente exclusivo para sua empresa</li>
            <li>✓ Atendimento 100% via WhatsApp</li>
          </ul>
        </section>

        <section className="qs-form-card">
          {expiraEm ? (
            <div className="qs-success-message" role="status">
              <span>✓</span>
              <h2>Demonstração criada</h2>
              <p>
                Seu acesso estará disponível até {new Date(expiraEm).toLocaleDateString("pt-BR")}.
                Use o e-mail e a senha cadastrados para entrar.
              </p>
              <Link className="qs-button qs-button-primary" to="/app">Acessar a plataforma</Link>
            </div>
          ) : (
            <form onSubmit={enviar}>
              <h2>Crie seu acesso</h2>
              <p>Todos os campos são obrigatórios.</p>
              <label>Seu nome<input name="nome" value={formulario.nome} onChange={atualizarCampo} required /></label>
              <label>Empresa<input name="empresa" value={formulario.empresa} onChange={atualizarCampo} required /></label>
              <label>E-mail<input name="email" type="email" value={formulario.email} onChange={atualizarCampo} required /></label>
              <label>WhatsApp<input name="whatsapp" type="tel" inputMode="numeric" maxLength="15" placeholder="(XX) 9XXXX-XXXX" value={formulario.whatsapp} onChange={atualizarCampo} required /></label>
              <div className="qs-form-row">
                <label>Senha<input name="senha" type={mostrarSenha ? "text" : "password"} minLength="6" value={formulario.senha} onChange={atualizarCampo} required /></label>
                <label>Confirmar senha<input name="confirmarSenha" type={mostrarSenha ? "text" : "password"} minLength="6" value={formulario.confirmarSenha} onChange={atualizarCampo} required /></label>
              </div>
              <label className="qs-consent">
                <input type="checkbox" checked={mostrarSenha} onChange={(event) => setMostrarSenha(event.target.checked)} />
                <span>Mostrar senha</span>
              </label>
              <label className="qs-consent">
                <input name="aceitouTermos" type="checkbox" checked={formulario.aceitouTermos} onChange={atualizarCampo} required />
                <span>
                  Li e concordo com o período de 7 dias, com o uso de um identificador protegido da rede para impedir
                  demonstrações repetidas e com os{" "}
                  <button
                    type="button"
                    className="qs-terms-link"
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      setMostrarContrato(true);
                    }}
                  >
                    Termos de Licença de Uso e Contrato de Prestação de Serviços
                  </button>.
                </span>
              </label>
              {erro && <div className="qs-form-error" role="alert">{erro}</div>}
              <button className="qs-button qs-button-primary" type="submit" disabled={enviando}>
                {enviando ? "Criando ambiente..." : "Iniciar demonstração"}
              </button>
            </form>
          )}
        </section>
      </main>
      {mostrarContrato && <ContratoLicencaModal onClose={() => setMostrarContrato(false)} />}
    </div>
  );
}
